// extracted by mini-css-extract-plugin
export default {"root":"FsdCxVt","green":"aFN5XR9","prepend":"sI834X1","caption":"OCgJla1","rightCaption":"xgBp6um"};